import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';

const CircleLoading = observer((props) => {
  const {
    className = '',
    icon = 'https://p1.ssl.qhimg.com/t11098f6bcd854eba5be3052458.png',
  } = props;

  return (
    <div className={`size-full relative overflow-visible ${className}`}>
      <div className="size-full ani-rotate" style={{
        background : `url(${icon}) center center / 100% 100% no-repeat`,
      }}></div>
    </div>
  )
});
export default CircleLoading;